<app-megamenu></app-megamenu>

<div class="service-page">
  <div class="hero-section">
    <div class="hero-background"></div>
    <div class="container">
      <div class="hero-content">
        <h1>Wasp Control Services</h1>
        <p class="hero-subtitle">Safe, professional wasp and hornet removal. Protect your family from dangerous stings with our expert nest removal services.</p>
        <div class="hero-actions">
          <button mat-raised-button class="cta-button" (click)="navigateToContact()">
            <mat-icon>pest_control</mat-icon>
            Get Wasp Removal
          </button>
          <button mat-button class="phone-button" (click)="callPhone()">
            <mat-icon>phone</mat-icon>
            Emergency: {{ config.phone.display }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <div class="container">
      <h2>Professional Wasp & Hornet Removal</h2>
      <p>Wasps and hornets can be aggressive and dangerous, especially when protecting their nests. Our trained professionals safely remove nests and eliminate wasp problems.</p>
      
      <div class="features-grid">
        <div class="feature-card">
          <mat-icon>security</mat-icon>
          <h3>Safe Nest Removal</h3>
          <p>Professional removal of wasp nests using proper safety equipment and techniques</p>
        </div>
        
        <div class="feature-card">
          <mat-icon>emergency</mat-icon>
          <h3>Emergency Service</h3>
          <p>Same-day service available for dangerous wasp situations</p>
        </div>
        
        <div class="feature-card">
          <mat-icon>shield</mat-icon>
          <h3>Prevention Treatment</h3>
          <p>Preventive treatments to discourage wasps from building new nests</p>
        </div>
      </div>
    </div>
  </div>

  <div class="warning-section">
    <div class="container">
      <div class="warning-content">
        <mat-icon>warning</mat-icon>
        <div class="warning-text">
          <h2>Wasp Emergency?</h2>
          <p>If you or someone has been stung multiple times or is allergic to wasp stings, seek medical attention immediately. We provide emergency wasp removal services.</p>
        </div>
        <button mat-raised-button class="emergency-btn" (click)="callPhone()">
          <mat-icon>phone</mat-icon>
          Emergency Removal
        </button>
      </div>
    </div>
  </div>

  <div class="cta-section">
    <div class="container">
      <h2>Safe Wasp Removal</h2>
      <p>Don't risk getting stung. Let our professionals safely remove wasp nests and protect your property.</p>
      <button mat-raised-button class="primary-cta" (click)="navigateToContact()">
        <mat-icon>pest_control</mat-icon>
        Schedule Removal
      </button>
    </div>
  </div>
</div>

<app-footer></app-footer>